import { FC, SVGAttributes } from 'react';

export const BendBigCircle: FC<SVGAttributes<SVGElement>> = ({ fill = '#089C9C', ...props }) => (
  <svg
    width="112"
    height="112"
    viewBox="0 0 112 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{
      minWidth: props.width ?? props.style?.width ?? 112,
      minHeight: props.height ?? props.style?.height ?? 112,
      ...props.style,
    }}
  >
    <rect x="0" y="0" width="112" height="112" rx="60" fill={fill} />
    <path
      d="M48.1926 32.3329C48.1926 29.7556 46.0229 27.6663 43.3464 27.6663C40.6699 27.6663 38.5002 29.7556 38.5002 32.3329V63.444C38.5002 74.6125 47.9023 83.6663 59.5002 83.6663C71.0982 83.6663 80.5002 74.6125 80.5002 63.444C80.5002 52.2756 71.0982 43.2218 59.5002 43.2218C56.8238 43.2218 54.6541 45.3112 54.6541 47.8885C54.6541 50.4658 56.8238 52.5552 59.5002 52.5552C65.7453 52.5552 70.8079 57.4303 70.8079 63.444C70.8079 69.4578 65.7453 74.3329 59.5002 74.3329C53.2552 74.3329 48.1926 69.4578 48.1926 63.444V32.3329Z"
      fill="white"
    />
  </svg>
);
